import { render, staticRenderFns } from "./auto-message-excluded-recipients.vue?vue&type=template&id=351b241a&scoped=true&"
import script from "./auto-message-excluded-recipients.vue?vue&type=script&lang=js&"
export * from "./auto-message-excluded-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b241a",
  null
  
)

export default component.exports